import { BASE } from "@/api/index";
import axios from "@/api/http";

const BASE_URL = BASE.PRO;

// 工单-列表
export function getCenterList(params = {}) {
  return axios.get(`${BASE_URL}/api/wo/center/list`, {params});
}
// 工单-基本信息
export function postCenterBaseInfo(params = {}) {
  return axios.post(`${BASE_URL}/api/wo/center/base/info`, params);
}

// 工单-保存审批
export function postApprovalSave(params = {}) {
  return axios.post(`${BASE_URL}/api/ap/approvalSave`, params);
}

// 工单-保存
export function postCenterSave(params = {}) {
  return axios.post(`${BASE_URL}/api/wo/center/save`, params);
}

// 工单-状态
export function postEntryStatusList(params = {}) {
  return axios.post(`${BASE_URL}/api/ap/entryStatusList`, params);
}

// 工单-作废
export function postCenterVoid(params = {}) {
  return axios.post(`${BASE_URL}/api/wo/center/void`, params);
}

// 工单-发送
export function postCenterDesk(params = {}) {
  return axios.post(`${BASE_URL}/api/wo/center/dispatch/finance/desk`, params);
}

// 工单-上传水单
export function postCenterUploadBill(params = {}) {
  return axios.post(`${BASE_URL}/api/wo/center/upload/bill`, params);
}

// 工单-详情
export function getCenterInfo(params = {}) {
  return axios.get(`${BASE_URL}/api/wo/center/info`, {params});
}

// oa迁移-列表
export function getOaList(params = {}) {
  return axios.get(`${BASE_URL}/api/ap/list`, {params});
}

// oa迁移-详情
export function postOaInfo(params = {}) {
  return axios.post(`${BASE_URL}/api/ap/info`, params);
}

// oa迁移-保存
export function postOaSave(params = {}) {
  return axios.post(`${BASE_URL}/api/ap/save`, params);
}

// oa迁移-发送审批
export function postOaSend(params = {}) {
  return axios.post(`${BASE_URL}/api/ap/send`, params);
}

// oa迁移-撤销
export function postOaRetract(params = {}) {
  return axios.post(`${BASE_URL}/api/ap/retract`, params);
}

// 审批-作废
export function postApprovalVoid(params = {}) {
  return axios.post(`${BASE_URL}/api/approval/void`, params);
}

// 审批-删除
export function postApprovalDelete(params = {}) {
  return axios.post(`${BASE_URL}/api/approval/delete`, params);
}

// oa迁移-重新发起审批
export function postOaReissue(params = {}) {
  return axios.post(`${BASE_URL}/api/ap/reissue`, params);
}

// 信用滞港-列表
export function postRiskSignalList(params = {}) {
  return axios.post(`${BASE_URL}/api/risk/signal/list`, params);
}